import BannerTrending from './Banner';
import TopCreator from './Creator';
import Rank from './Rank';
import TrendingType from './Type';

const MarketTrending = () => {
  return (
    <div className="py-6">
      <BannerTrending />
      <Rank />
      <TopCreator />
      <TrendingType />
    </div>
  );
};

export default MarketTrending;
